import { ISusuarioList, UsuarioList } from '../../types/usuario/UsuarioList';
import { MenuFilho } from '../menuFilho/MenuFilho';
import { ISnoticiaList, NoticiaList } from '../noticia/Noticia';

export interface MenuPai {
  id?: string;
  label: string;
  link?: string;
  noticia?: NoticiaList;
  ordem?: number;
  children?: MenuFilho[];
  dataHoraCriacao?: Date | string;
  usuario?: UsuarioList;
  isEscolaLegislativo?: boolean;
}
export const ISmenuPai: MenuPai = {
  id: '',
  label: '',
  children: [],
  link: '',
  ordem: 0,
  noticia: ISnoticiaList,
  dataHoraCriacao: '',
  usuario: ISusuarioList,
  isEscolaLegislativo: false
};
export interface MenuPaiList {
  id?: string;
  label: string;
  link: string;
  ordem?: number;
  idNoticia: string;
  dataHoraCriacao?: Date | string;
  usuario: UsuarioList;
  isEscolaLegislativo?: boolean;
}
export const ISmenuPaiList: MenuPaiList = {
  id: '',
  label: '',
  link: '',
  ordem: 0,
  idNoticia: '',
  dataHoraCriacao: '',
  usuario: ISusuarioList,
  isEscolaLegislativo: false
};

export interface MenuPaiDTO {
  id?: string;
  link?: string;
  label: string;
  ordem: number;
  idNoticia?: string;
  isEscolaLegislativo?: boolean;
}
export const ISmenuPaiDTO: MenuPaiDTO = {
  id: '',
  link: '',
  label: '',
  idNoticia: '',
  ordem: 0,
  isEscolaLegislativo: false
};
